import { Autocomplete, Box, TextField } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAnnotatorSelection } from './useAnnotatorSelection';

export const AnnotatorSelection = () => {
  const {
    annotatorOptions,
    allAnnotatorOption,
    selectedAnnotatorId,
    handleAnnotatorChange,
    isAnnotatorDataLoading,
    selectedProjectId,
  } = useAnnotatorSelection();
  const { formatMessage } = useIntl();
  return (
    <Box sx={{ width: '50%' }}>
      <Autocomplete
        disabled={isAnnotatorDataLoading || !selectedProjectId}
        options={annotatorOptions}
        getOptionLabel={(o) => o.label}
        value={annotatorOptions.find((o) => o.id === selectedAnnotatorId) || allAnnotatorOption}
        onChange={(_, newValue) => handleAnnotatorChange(_, newValue?.id || allAnnotatorOption.id)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={formatMessage({ id: 'metrics.dashboard.annotatorDropdown.label' })}
          />
        )}
      />
    </Box>
  );
};
